import React from 'react'
import WidgetSelector from './WidgetSelector'

export default function WidgetItemSelector({
  value,
  displayValue,
  items,
  onChange,
  viewOnly,
  reloadDropdownData,
  size,
  placeHolder,
}) {
  return (
    <WidgetSelector
      key={value || 'reset-item'} // 🔥 THIS IS THE FIX
      viewOnly={viewOnly || false}
      selectedValue={value}
      displayValue={displayValue}
      options={items}
      onChange={(values) => onChange(values)}
      reloadDropdownData={() => reloadDropdownData()}
      placeHolder={placeHolder}
      showCloudIcon={true}
      size={size}
    />
  )
}
